<template>
  <!-- 流程图组件 -->
  <div class="FlowChart">
    <div class="steps" v-if="details['WorkflowActionList']">
      <div class="seal">
        <img :src="details.Status === 4 ? '/static/picture/rejected.png' : details.Status === 1 ? '/static/picture/finish.png' : '/static/picture/through.png'" alt />
      </div>
      <el-steps direction="vertical" :active="details['WorkflowActionList'].length" align-center>
        <el-step v-for="(item, i) in details.WorkflowActionList" :title="item.WorkflowNodeName" :key="i" :icon="item.ActionName === '驳回' ? 'el-icon-error' : 'el-icon-success'">
          <template #description>
            <div class="description-item" :class="{ rejected: item.ActionName === '驳回' }">
              <div class="description-item-top">
                <div class="OperatorName">{{ item.OperatorName }}</div>
                <div class="OperateTime">
                  <div class="deviceIcon">
                    <img :src="item.DeviceType == 1 ? '/static/picture/mobile.png' : '/static/picture/pc.png'" alt v-if="!(item.DeviceType === null)" />
                  </div>
                  {{ $common.timesToTime(item.OperateTime, true) }}
                </div>
              </div>
              <div class="description-item-center">已{{ item.ActionName }}</div>
              <div class="description-item-bottom" v-if="!!item.ActionRemark">操作备注： {{ item.ActionRemark }}</div>
            </div>
          </template>
        </el-step>
        <el-step :title="details.CurrentNode['FullName']" icon="el-icon-a-shijian3" v-if="!!details.CurrentNode">
          <template #description>
            <div class="description-item" :class="{ 'awit-audit': !!details.CurrentNode }">
              <div class="description-item-top">
                <span class="OperatorName">{{ !!details.CurrentOperatorNames ? details.CurrentOperatorNames : details.CurrentNode['Name'] }}</span>
              </div>
              <div class="description-item-center">{{ details.CurrentNode['IsStartPoint'] ? '待处理' : '待审批' }}</div>
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <template v-if="$slots['user-defined']">
      <!-- 流程图底部插槽，可自定义按钮 -->
      <slot name="user-defined"></slot>
    </template>
    <template v-else>
      <div v-if="details.Status === 1 && selTab == 2">
        <div class="submitItem">
          <el-button type="danger" class="btn" @click="operation('rejected')">驳 回</el-button>
          <el-button type="primary" class="btn" @click="operation('pass')">通 过</el-button>
        </div>
      </div>
    </template>
    <reject-dialog :isShow.sync="isShowRejectDialog" :remarkRequired="remarkRequired" :type="dialogType" :tip="rejectTip" @reject="confirmHandler" />
  </div>
</template>
<script>
import { ApproveBidProjectTraceWorkflow } from '@/http/api';
import { fetchSysDicList } from '@/http/dictionary';

export default {
  name: 'FlowChart',
  props: {
    details: {
      type: Object,
      default: () => {},
    },
    TemplateID: {
      // 流程的userid
      type: Number,
      default: null,
    },
    selTab: {
      // 当前分类：我提交的、待我审批的、我已审批的
      type: Number,
      default: '',
    },
    passTip: {
      // 通过提示语
      type: String,
      default: '您是否通过当前流程',
    },
    rejectTip: {
      // 驳回提示语
      type: String,
      default: '当前流程',
    },
  },
  data() {
    return {
      url: '',
      isShowRejectDialog: false,
      dialogType: '',
      remarkRequired: true,
      action: '',
    };
  },
  created() {
    this.getDicList(this.TemplateID);
  },
  watch: {
    TemplateID: {
      handler(newVal) {
        // console.log("newVal", newVal);
        this.getDicList(newVal);
      },
    },
  },
  methods: {
    // 获取部分接口链接
    getDicList(val) {
      fetchSysDicList('BasicData', 'AuditFlow').then((res) => {
        res.forEach((item) => {
          if (item.Name * 1 === val) {
            this.url = item.Title;
          }
        });
      });
    },
    operation(query) {
      this.action = query === 'pass' ? 'Approve' : 'Refuse';
      this.dialogType = query === 'pass' ? '通过' : '驳回';
      this.remarkRequired = query === 'rejected';
      this.isShowRejectDialog = true;
    },
    confirmHandler({ success, complete, remark }) {
      ApproveBidProjectTraceWorkflow(this.action, this.details.ID, remark, this.url)
        .then(({ Code, Message }) => {
          if (Code == 1) {
            this.$emit('close');
            success();
          } else {
            this.$message.error(Message);
          }
        })
        .finally((_) => complete());
    },
  },
};
</script>
<style lang="less" scoped>
@import './index.less';
.steps /deep/ .el-step.is-vertical .el-step__title {
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  color: #999999;
}
.steps /deep/ .el-icon-success {
  background-image: linear-gradient(#369bff, #64b5fe);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.steps /deep/ .el-icon-error {
  background-image: linear-gradient(#fb0000, #fe6262);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.steps /deep/ .el-icon-a-shijian3 {
  background-image: linear-gradient(#faad21, #ffbb6d);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.steps /deep/ .el-step__head.is-finish {
  border-color: #eee;
}
.steps /deep/ .el-step__icon-inner {
  font-size: 16px;
}
</style>
